export default __webpack_public_path__ + "static/media/sneakerDetailBg.19e57981.png";